import { Form, Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { ProcedureTemplateInstance } from '@/backend/models/procedureInstances/procedureTemplateInstance';
import { I18n } from '@/i18n/I18n';
import { BasicButton } from '../buttons/BasicButton';
import { useProcedureListStore } from '@/frontend/store/ProcedureListStore';
import { useNavigate } from 'react-router-dom';
import { Select } from '../Select';

export function CreateFromTemplateModal() {
  const initializeProcedureFromTemplate = useProcedureListStore((state) => state.initializeProcedureFromTemplate);
  const templates = useProcedureListStore((state) => state.templates);
  const [showModal, setShowModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<ProcedureTemplateInstance>();
  const [templateList, setTemplateList] = useState<(ProcedureTemplateInstance)[]>(templates);
  const [error, setError] = useState<string>('');
  const navigate = useNavigate();
  
  const onClickCreate = async () =>  {
    if (!selectedTemplate) {
      setError(I18n.get('required'));
      return;
    }
    const response = await initializeProcedureFromTemplate(selectedTemplate.id);
    if(response.status === 200) {
      void navigate(`/procedureCreate/${response.procedureInstance.id}`);
    }
    closeModal();
  };

  useEffect(() => {
    setTemplateList(templates);
  }, [templates]);

  const closeModal = () => {
    setShowModal(false);
    setSelectedTemplate(undefined);
    setTemplateList(templates);
    setError('');
  };

  function handleSearch(searchString: string) {
    if (searchString === '') {
      setTemplateList(templates);
    } else {
      const filteredTemplates = templates.filter((template) => template.title.toLowerCase().includes(searchString.toLowerCase()));
      setTemplateList(filteredTemplates);
    }
  }

  function selectTemplate(template: ProcedureTemplateInstance) {
    setSelectedTemplate(template);
    setError('');
  }

  return (
    <>
      <BasicButton className='btn btn-primary btn-sm align-self-end' onClick={() => setShowModal(true)} label={I18n.get('createFromTemplate')} />
      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{I18n.get('createProcedure')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Label>{I18n.get('Template')}</Form.Label>
          <Select value={selectedTemplate?.title || I18n.get('selectTemplate')} label={I18n.get('selectTemplate')}>
            <input className='form-control' type="text" placeholder={I18n.get('search')} onChange={(event) => handleSearch(event.target.value)} />
            {templateList.map((template) => (
              <button type="button" key={template.id} className="w-100 dropdown-item" onClick={() => selectTemplate(template)}>{template.title}</button>
            ))}
          </Select>
          <p className='col-12 text-danger'>{error}</p>
        </Modal.Body>
        <Modal.Footer>
          <BasicButton className='btn btn-secondary' aria-label={I18n.get('cancel')} onClick={closeModal} label={I18n.get('cancel')} />
          <BasicButton
            className="btn btn-primary" 
            onClick={onClickCreate}
            style={{ width: '85px' }}
            aria-label={I18n.get('create')}
            label={I18n.get('confirm')}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}
